import NextI18Next from 'next-i18next';

const NextI18NextInstance = new NextI18Next({
  defaultLanguage: 'en',
  otherLanguages: ['de', 'sv'],
  ignoreRoutes: ['/_next/', '/static/', '/public/', '/api/'],
  localeSubpaths: {
    de: 'de',
    sv: 'sv',
  },
  serverLanguageDetection: false,
});

export const {
  appWithTranslation,
  useTranslation,
  i18n,
  withTranslation,
  Router,
  Link,
  Trans,
} = NextI18NextInstance;

export default NextI18NextInstance;
